import React from "react";
import { productRangeManagementStore } from "../../../data/states/product_range_management_store.ts";
import { Button, FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, Typography } from "@mui/material";

type CreateProductRangeSelectorProps = {
    selectedRangeId: string | undefined,
    onSelect: (selectedId: string | undefined) => void,
}


export const CreateProductRangeSelector: React.FC<CreateProductRangeSelectorProps> = (
    props: CreateProductRangeSelectorProps,
) => {
    const { productRanges, retry } = productRangeManagementStore();

    const {
        selectedRangeId,
        onSelect,
    } = props;

    return productRanges.when(
        (data) => {
            return <FormControl>
                <InputLabel id="product-range-selector-label">Range</InputLabel>
                <Select
                    labelId="product-range-selector-label"
                    value={selectedRangeId ?? ''}
                    input={<OutlinedInput label="Range" />}
                    onChange={(v: SelectChangeEvent<string>) => {
                        onSelect(v.target.value)
                    }}
                >
                    <MenuItem
                        key={'none'}
                        value={undefined}
                    >
                        {"None"}
                    </MenuItem>
                    {
                        data.map(
                            (item) => <MenuItem
                                key={item._id}
                                value={item._id}
                            >
                                {item.localisedValue}
                            </MenuItem>
                        )
                    }
                </Select>
            </FormControl>
        },
        (error) => {
            return <Button
                variant="outlined"
                onClick={retry}
            >
                RETRY PRODUCT RANGE LOAD
            </Button>;
        },
        () => {
            return <Typography>Loading productt ranges</Typography>
        },
    )
}